
import {
  onBeforeMount,
  onUnmounted,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
} from "vue";
import card_content_json from "/public/lottie/card_content/card_content.json";
import newcard_l0_json from "/public/lottie/newcard_l0/newcard_l0.json";
import newcard_l1_json from "/public/lottie/newcard_l1/newcard_l1.json";
import newcard_l2_json from "/public/lottie/newcard_l2/newcard_l2.json";
import newcard_l3_json from "/public/lottie/newcard_l3/newcard_l3.json";
import "@lottiefiles/lottie-player";
import lottie from "lottie-web";
// import default_img from "@/assets/images/aio/pop-card.png"
import { dealLottiePath } from "../../utils/prefixLottie";
import { doJump, nativeToast } from "@/utils/nativeFn";
import { compareVersion } from '@/utils/compareVersion'
import { prop } from 'vue-class-component';
import {noScroll, refreshScroll} from '../../assets/js/utils.js'
export default {
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    versionName: {
      type: String,
      default: '0', 
    },
    type: {
      type: Number,
      default: 1, // 1 知识点详情， 2 升级弹框
    },
    cardInfo: {
      type: Object,
      default: () => ({
        cardImage: "",
        cardName: "",
        cardDesc:"",
        currentLevel: 0,
        skuName: "",
        skuId: "",
        rewardContent: "",
        cardType: 2, // 1无星 2有星
        btnJumpType: 0,
        btnJumpUrl: '',
        btnJumpText: ''
      }),
    },
    doShare: {
      type: Function,
      default: () => {
        console.log("share");
      }, // 去分享
    },
    doClose: {
      type: Function,
      default: () => {
        console.log("close");
      }, // 关闭
    },
    doSee: {
      type: Function,
      default: () => {
        console.log("see");
      }, // 看一看
    },
  },
  emits: ["doSee", "doClose", "doShare"],
  setup(props, { emit }) {
    const reportDataMap = {
      page_name: "knowledge_card_detail",
      sku_name: props.cardInfo?.skuName || "",
      card_name: props.cardInfo?.cardName || "",
      sku_unid: props.cardInfo?.skuId + "" || "",
    };
    const $xesLog = inject("$xesLog") as any; // 埋点
    const showThirdBtn = compareVersion(props.versionName, '1.8.0') > -1 && props?.cardInfo?.btnJumpText && props?.cardInfo?.btnJumpUrl
    // console.log('showThirdBtn', props.versionName, props?.cardInfo?.btnJumpText, props?.cardInfo?.btnJumpUrl)
    onMounted(() => {
      // 弹窗曝光
      props.cardInfo?.currentLevel && $xesLog.track("pop_up_element_show", {
        ...reportDataMap,
        
        pop_up_name: "star_win_pop_up",
        pop_up_status: props.cardInfo?.currentLevel || "",
      });
      checkPhoneHeight();
      getLottie();
      noScroll()
    });
    onUnmounted(() => {
      console.log('弹窗关闭')
      refreshScroll()
      emit("doClose");
    });
    const isSmallPhone = ref(false);
    const isBigPhone = ref(false);
    const close = () => {
      // 关闭
      $xesLog.track("button_click", {
        ...reportDataMap,
        button_name: "pop_up_button",
        pop_up_button_status: "0",
      });
      refreshScroll()
      emit("doClose");
    };
    const see = () => {
      // 去查看
      $xesLog.track("button_click", {
        ...reportDataMap,
        button_name: "pop_up_button",
        pop_up_button_status: "1",
        button_location: props.type === 1 ? '卡牌详情' : '升级弹窗'
      });
      refreshScroll()
      emit("doSee");
    };
    const share = () => {
      // 分享
      $xesLog.track("button_click", {
        ...reportDataMap,
        button_name: "pop_up_button",
        pop_up_button_status: "2",
        button_location: props.type === 1 ? '卡牌详情' : '升级弹窗'
      });
      refreshScroll()
      emit("doShare");
    };
    const checkPhoneHeight = () => {
      let h = document.documentElement.clientHeight;
      console.log(h, "------h----");
      if (h < 740) {
        isSmallPhone.value = true;
      }
    };
    const getLottie = () => {
      let lottie_json;
      // console.log(default_img,'default_img')
      // console.log(card_content_json,'card_content_json')
      if (props.type === 1) {
        lottie_json = card_content_json; // 详情
      } else if (props.type === 2 && props.cardInfo.cardType != 2) {
        lottie_json = newcard_l0_json; // 无星弹窗
      } else if (props.type === 2 && props.cardInfo.currentLevel === 1) {
        lottie_json = newcard_l1_json;
      } else if (props.type === 2 && props.cardInfo.currentLevel === 2) {
        lottie_json = newcard_l2_json;
      } else if (props.type === 2 && props.cardInfo.currentLevel === 3) {
        lottie_json = newcard_l3_json;
      }
      const lottiePath = "images/";
      const newLottiePath = dealLottiePath(lottiePath);
      lottie_json?.assets && lottie_json.assets?.forEach((item) => {
        item.u = newLottiePath;
      });
      // console.log(props.cardInfo.cardImage, "props.cardInfo.cardImage");
      const asset =
        props.type === 1
          ? lottie_json?.assets?.find((a) => a.id === "image_0")
          : lottie_json?.assets?.find((a) => a.id === "image_1");
      if (props.cardInfo?.cardImage) {
        asset.u = "";
        asset.p = props.cardInfo?.cardImage;
      }
      lottie.loadAnimation({
        container: document.getElementById("detail-lottie-main"), // the dom element that will contain the animation
        renderer: "svg",
        loop: false,
        animationData: lottie_json, // the path to the animation json
      });
    };
    const handleJump = () => {
      doJump(props?.cardInfo?.btnJumpUrl, () => {
        console.log("第三个按钮跳转成功");
      });
      emit("doClose");
      $xesLog.track("button_click", {
        ...reportDataMap,
        button_name: "pop_up_button",
        pop_up_button_status: "3",
      });
    }
    return {
      close,
      see,
      share,
      isSmallPhone,
      isBigPhone,
      handleJump,
      showThirdBtn
    };
  },
};
